import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * The Sąskaitos module tabs: Pardavimai | Pirkimai | Skenavimas | Šablonas.
 * Rendered ONCE by InvoicesLayout so switching keeps the strip on screen and
 * only the content below swaps - they act as real tabs, not page navigation.
 */
const TABS = [
  { path: '/invoices/made', key: 'invoices.salesTab' },
  { path: '/invoices/received', key: 'invoices.purchasesTab' },
  { path: '/invoices/scan', key: 'invoices.scanTab', icon: '📄' },
  { path: '/invoices/template', key: 'invoices.templateTab', icon: '🎨' },
];

export default function InvoicesTabs() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isActive = (path: string) =>
    pathname === path || (path === '/invoices/made' && pathname === '/invoices');

  return (
    <div className="flex gap-1 border-b border-gray-200">
      {TABS.map(tab => (
        <button
          key={tab.path}
          className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
            isActive(tab.path)
              ? 'border-primary-600 text-primary-600'
              : 'border-transparent text-gray-500 hover:text-gray-700'
          }`}
          onClick={() => navigate(tab.path)}
        >
          {tab.icon ? `${tab.icon} ` : ''}{t(tab.key)}
        </button>
      ))}
    </div>
  );
}
